export const GA_TRACKING_ID = "G-M1PW3PQ3RB"